import axios from 'axios';
import prepareRequestOptions from '../utils/admin-apis.util';

export const getRulesetScheduleData = async (channelId, params = '') => {
  const options = prepareRequestOptions(
    `/admin/channel/${channelId}/content/schedule/list${params}`,
    'GET',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const manageChannelScheduleContentInfo = async (id, payload) => {
  const options = prepareRequestOptions(
    `/admin/channel/${id}/content/schedule/manage`,
    'POST',
    payload,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const getChannelAssignRulesetVideos = async (
  id,
  channelId,
  params = '',
  signal = null
) => {
  const options = prepareRequestOptions(
    `/admin/channel/${channelId}/content/schedule-info/${id}/videos${params}`,
    'GET',
    null,
    true,
    signal
  );

  const response = await axios(options);
  return response.data;
};

export const rulesetbaseAddVideoById = async (id) => {
  const options = prepareRequestOptions(
    `/admin/content/channels/${id}/ruleset/add-videos`,
    'POST',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const rulesetbaseIncrementalAddVideoById = async (id) => {
  const options = prepareRequestOptions(
    `/admin/content/channels/${id}/ruleset/incremental/add-videos`,
    'POST',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const purgeChannelVideosAssignment = async (id) => {
  const options = prepareRequestOptions(
    `/admin/content/channels/${id}/assignment/purge`,
    'POST',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const getRulesetById = async (id) => {
  const options = prepareRequestOptions(
    `/admin/channel/content/schedule/ruleset/${id}/view`,
    'GET',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};
export const createRuleset = async (payload) => {
  const options = prepareRequestOptions(
    `/admin/channel/content/schedule/ruleset/create`,
    'POST',
    payload,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const updateRuleset = async (payload) => {
  const options = prepareRequestOptions(
    `/admin/channel/content/schedule/ruleset/update`,
    'POST',
    payload,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const deleteRulesetDataById = async (id) => {
  const options = prepareRequestOptions(
    `/admin/channel/content/schedule/ruleset/${id}/delete`,
    'DELETE',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const generateChannelVideosSchedule = async (id, type) => {
  const options = prepareRequestOptions(
    `/admin/channel/${id}/content/schedule/generate?type=${type}`,
    'POST',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const generateIncrementalChannelVideosSchedule = async (id, type) => {
  const options = prepareRequestOptions(
    `/admin/channel/${id}/content/schedule/generate/incremental?type=${type}`,
    'POST',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const purgeChannelVideosSchedule = async (id, type) => {
  const options = prepareRequestOptions(
    `/admin/channel/${id}/content/schedule/purge?type=${type}`,
    'POST',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const saveNewChannelRelease = async (id, payload) => {
  const options = prepareRequestOptions(
    `/admin/channel/${id}/content/schedule/new-release/manage`,
    'POST',
    payload,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const saveNewChannelSchedule = async (id, payload) => {
  const options = prepareRequestOptions(
    `/admin/channel/${id}/content/schedule/new-channel-schedule`,
    'POST',
    payload,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const deleteNewChannelReleaseById = async (id) => {
  const options = prepareRequestOptions(
    `/admin/channel/content/schedule/new-release/${id}/delete`,
    'DELETE',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const getScheduleReport = async (id, params = '') => {
  const options = prepareRequestOptions(
    `/admin/channel/${id}/content/schedule/report${params}`,
    'GET',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const validateChannelSchedule = async (id, payload) => {
  const options = prepareRequestOptions(
    `/admin/content/channel/${id}/validate-schedule`,
    'POST',
    payload,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const manageRulesetsSequence = async (payload, id) => {
  const options = prepareRequestOptions(
    `/admin/channel/content/schedule/${id}/rulesets/sequence/manage`,
    'POST',
    payload,
    true
  );

  const response = await axios(options);
  return response.data;
};
